export default "__VITE_ASSET__BVDmzrSs__"